import React from "react";
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

const About = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-vh-100 d-flex flex-column"
      style={{ backgroundColor: "#ffeae9", padding: "2rem" }}
    >

      <div className="mb-4">
        <button
          className="btn btn-light border rounded-circle"
          style={{ width: "42px", height: "42px" }}
          onClick={() => navigate("/")}
        >
          <img
            src="/arrow_back.png"
            alt="Go Back"
            style={{ width: "22px", height: "22px" }}
          />
        </button>
      </div>

      <div className="container bg-white rounded-4 shadow p-4">
        <h1 className="text-center mb-4">About EduLink</h1>
        <p className="fs-5">
          EduLink is an online platform designed to connect students and tutors in a simple, intuitive, and interactive way.
          Our goal is to bridge the gap between learning and teaching by providing a dedicated space where:
        </p>
        <ul className="fs-5">
          <li>Students can find expert teachers in any subject</li>
          <li>Tutors can manage their courses and resources</li>
          <li>A collaborative environment fosters better education</li>
        </ul>
        <p className="fs-5">
          Whether you're a student seeking help or a teacher looking to inspire — EduLink is your digital classroom.
        </p>
      </div>
    </div>
  );
};

export default About;
